import { render, staticRenderFns } from "./OrderManage.vue?vue&type=template&id=4cc16a3c&scoped=true&"
import script from "./OrderManage.vue?vue&type=script&lang=js&"
export * from "./OrderManage.vue?vue&type=script&lang=js&"
import style0 from "./OrderManage.vue?vue&type=style&index=0&id=4cc16a3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc16a3c",
  null
  
)

export default component.exports